import { atom } from "@reatom/core"

import { CatalogSearchQuery } from "modules/PsyCatalog/common/searchQuery"
import { ctx } from "modules/PsyCatalog/common/ctx"

const keys: (keyof CatalogSearchQuery)[] = [
    "age_from",
    "age_to",
    "city",
    "competences",
    "express_slots",
    "form_of_work",
    "has_children",
    "marital_status",
    "methods",
    "price_from",
    "price_to",
    "sex",
    "working_with",
]

const fieldsState = Object.fromEntries(keys.map((key) => [key, atom("init")]))

const readyAtom = atom((ctx) => {
    const result = Object.fromEntries(keys.map((key) => [key, "init"]))
    for (const [field, stateAtom] of Object.entries(fieldsState)) {
        result[field] = ctx.spy(stateAtom)
    }
    return keys.every((k) => result[k] === "ready")
})

export interface FieldStatus {
    setReady(field: keyof CatalogSearchQuery): void
    readyAtom: typeof readyAtom
}

function setReady(field: keyof CatalogSearchQuery) {
    fieldsState[field](ctx, "ready")
}

export const FieldStatus: FieldStatus = {
    setReady,
    readyAtom,
}
